import { createCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';

import { isBirthdayError, isPhoneError } from './is-error';

export const getPhoneCaption = createCaption(isPhoneError);
export const getBirthdayCaption = createCaption(isBirthdayError);
